String.prototype.replaceAll = function (search, replacement) {
    const target = this;
    return target.split(search).join(replacement);
};
var VM = function () {
    const self = this;
    self.input = ko.observable("");
    self.input.subscribe(function (newValue) {
        if (newValue) {
            let output = "var text = @\"\n";
            output += newValue.replaceAll("\"", "\"\"");
            output += "\n\";";
            self.content(output);
            self.showResult(true);
            // Hljs response
            const converterResponse = document.querySelector('#converter-response');
            converterResponse.querySelectorAll('pre code').forEach((block) => {
                hljs.highlightBlock(block);
            });
        } else {
            self.showResult(false);
        }
    });
    self.showResult = ko.observable(false);
    self.content = ko.observable();

    // Copy to clipboard button
    var copyMultiline = new ClipboardJS('#cpybutton', {
        text: function () {
            return document.querySelector('.stacktrace').innerText;
        }
    });
    copyMultiline.on('success', function(e) {
        e.clearSelection();
        const cpyButton = new bootstrap.Tooltip(document.querySelector('#cpybutton'));
        cpyButton.show();
        setTimeout(() => cpyButton.hide(), 1000);
    });

    self.shareToolbox = ko.pureComputed({
        read: function () {
            var url = encodeURIComponent(window.location.href),
                title = encodeURIComponent(document.title),
                description = encodeURIComponent(document.getElementsByName('description')[0].getAttribute('content'));
            
            return { 
                facebook: 'https://www.facebook.com/sharer.php?u=' + url,
                twitter: 'https://x.com/intent/tweet?url=' + url + '&text=' + title,
                linkedin: 'https://www.linkedin.com/sharing/share-offsite/?url=' + url,
                email: 'mailto:?subject=' + title + '&body=' + description + ' Link: ' + url
            };
        },
        owner: this
    });
};

document.addEventListener("DOMContentLoaded", function () {
    var vm = new VM();
    ko.applyBindings(vm, document.body);

    // Hljs more description
    const moreDescription = document.querySelector('.more-description');
    moreDescription.querySelectorAll('pre code').forEach((block) => {
        hljs.highlightBlock(block);
    });
});